var render = function render(){var _vm=this,_c=_vm._self._c;return _c('properties-block',_vm._g(_vm._b({},'properties-block',_vm.$props,false),_vm.$listeners),[_c('properties-component-glyph',_vm._b({attrs:{"title":"Glyph|Icône","value":_vm.block.glyph}},'properties-component-glyph',_vm.componentProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }